module.exports = __webpack_public_path__ + "media/4.c394941e.mp3";